var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content animate-panel",attrs:{"id":"content"}},[_c('h2',{staticClass:"m-n"},[_vm._v("紹介制度")]),_vm._v(" "),_c('div',{staticClass:"hpanel"},[_c('nav-tabs',{attrs:{"tab":_vm.tab,"disabled":_vm.disabledTab}}),_vm._v(" "),_c('tab-content',{attrs:{"tab":_vm.tab},on:{"checkData":_vm.checkData}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c6ded1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/affiliate/Affiliate.vue
// module id = null
// module chunks = 